import { type ReactNode } from 'react';
import { Navigate }       from 'react-router-dom';

import { useAuthStore }   from '../store/authStore';
import { type Role }      from '@/constants/roles';

interface RoleRouteProps {
  children: ReactNode;
  /** Roles that are permitted to access this route */
  allowed:  Role[];
}

export function RoleRoute({ children, allowed }: RoleRouteProps) {
  const { user } = useAuthStore();

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  if (!allowed.includes(user.role as Role)) {
    // Authenticated but unauthorised → send to dashboard
    return <Navigate to="/dashboard" replace />;
  }

  return <>{children}</>;
}